import { ReactLenis } from "lenis/react";
import { useEffect, useState } from "react";
import { trackPageview } from "@/lib/analytics";
import { api } from "@/lib/api";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/EditorialMarquee";
import { About } from "@/components/site/About";
import { Manifesto } from "@/components/site/Manifesto";
import { EventsCalendar } from "@/components/site/EventsCalendar";
import { Sections } from "@/components/site/Sections";
import { RequestForm } from "@/components/site/RequestForm";
import { Footer } from "@/components/site/Footer";
import { WelcomeTicketModal } from "@/components/site/WelcomeTicketModal";
import { ComingSoon } from "@/components/site/ComingSoon";

export default function Landing() {
  const [live, setLive] = useState(null);

  useEffect(() => {
    api.get("/site/status").then((r) => setLive(r.data.live)).catch(() => setLive(true));
  }, []);

  useEffect(() => { if (live) trackPageview("/"); }, [live]);

  if (live === null) return <div className="min-h-screen bg-[#0A0A0A]" data-testid="landing-loading" />;
  if (!live) return <ComingSoon />;

  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="bg-[#070202]" data-testid="landing-page">
        <WelcomeTicketModal />
        <Navbar />
        <Hero />
        <EditorialMarquee />
        <About />
        <Manifesto />
        <EventsCalendar />
        <Sections />
        <RequestForm />
        <Footer />
      </div>
    </ReactLenis>
  );
}
